import { parseTimezoneFromContact } from "../utils/helpers";
import { PropTypes } from "base/react-libs";
import { Icon } from "@evertrue/et-components";
import { useGate } from "components/is-gated";

const ContactTimezoneIndicator = ({ contact = {} }) => {
  const [enabled, loaded] = useGate("unreleased_feature"); // this will be a different gate upon release
  const timezone = parseTimezoneFromContact(contact);

  if (!loaded) return null;
  if (enabled) {
    return (
      timezone && (
        <div className="contact-timezone-indicator" style={{ marginLeft: "5px" }}>
          <Icon icon="timezone" iconKit="gt2" />
          <div style={{ fontSize: "x-small" }}>{timezone}</div>
        </div>
      )
    );
  } else {
    return null;
  }
};

ContactTimezoneIndicator.propTypes = {
  contact: PropTypes.object,
};

export default ContactTimezoneIndicator;
